import React from 'react';

function Terms() {
  return (
    <div className="container mx-auto p-8">
      <div className="bg-white rounded-lg mt-8 shadow-lg p-6 text-left border border-gray-400">
        <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
        
        <div className="space-y-4">
          <p className="font-bold">Last Updated: April 5, 2025</p>

          <section className="mb-6">
            <h2 className="text-2xl font-bold mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing and using ATL Tech Events<sup>SM</sup> (atltech.events), you accept and agree to be 
              bound by the terms and provisions of this agreement.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-bold mb-3">2. Use License</h2>
            <p>
              Permission is granted to temporarily view the materials (information or software) on 
              ATL Tech Events<sup>SM</sup> for personal, non-commercial transitory viewing only.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-bold mb-3">3. Disclaimer</h2>
            <p>
              The materials on ATL Tech Events<sup>SM</sup> are provided on an 'as is' basis. We make no 
              warranties, expressed or implied, and hereby disclaim and negate all other warranties 
              including, without limitation, implied warranties or conditions of merchantability, 
              fitness for a particular purpose, or non-infringement of intellectual property or 
              other violation of rights.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-bold mb-3">4. Event Information</h2>
            <p>
              While we strive to maintain accurate and up-to-date event information, we cannot 
              guarantee the accuracy of all event details. Users should verify event details with 
              the respective event organizers.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3">5. Limitations</h2>
            <p>
              In no event shall ATL Tech Events<sup>SM</sup>, its publisher Mirability, LLC, or its suppliers be liable for any damages 
              (including, without limitation, damages for loss of data or profit, or due to business 
              interruption) arising out of the use or inability to use the materials on ATL Tech Events<sup>SM</sup>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Terms; 